import { dataInterface as stubImplementation } from '@ardoq/data-interface';
import { dataInterface } from './dataInterface';

export const initializeDataInterface = () => {
  stubImplementation.registerImplementation({
    ...dataInterface,
  });
};
